import multiavatar from '@multiavatar/multiavatar/esm'

export function generateAccountAvatar(userNo: string) {
  const svg = multiavatar(String(userNo))
  return `data:image/svg+xml;charset=utf-8,${encodeURIComponent(svg)}`
}
